import { TIPOS_SERVICIO_VIAJE_TRASLADO, TipoServicioLabel } from "app/viaje/models"

export enum COLORS_TYPES {
    GREEN = 'GREEN',
    YELLOW = 'YELLOW',
    ORANGE = 'ORANGE',
    RED = 'RED'
}

export const colorsOptions = Object.values(COLORS_TYPES).map(color => ({
    value: color,
    label: color.toLowerCase()
})) 



export const servicesOptions = TIPOS_SERVICIO_VIAJE_TRASLADO.map(service => ({
    value: service,
    label: TipoServicioLabel[service]
}))

export const polygonOptions = [
    {value: 'polygon1', label: 'Polígono 1'},
    {value: 'polygon2', label: 'Polígono 2'},
    {value: 'polygon3', label: 'Polígono 3'},
]


export const trafficLightOptions = [
    {  color_key: 'green', color: COLORS_TYPES.GREEN, label: 'bg-greenTrafficLight' },
    {  color_key: 'yellow', color: COLORS_TYPES.YELLOW, label: 'bg-yellowTrafficLight' },
    {  color_key: 'orange', color: COLORS_TYPES.ORANGE, label: 'bg-orangeTrafficLight' },
    {  color_key: 'red', color: COLORS_TYPES.RED, label: 'bg-redTrafficLight' },
]